<div class="container-error">
  <div class="doc-container">
    <h1>Attenzione</h1>
    <p>Il processo di firma è andato in errore. Si prega di ripartire dal link ricevuto via email.
    </p>
  </div>

</div>